<div class="top_section">
  <div class="slider">
    <div class="slides" [style.transform]="'translateX(' + (-currentSlide * 100) + '%)'">
      <div class="slide" *ngFor="let slide of sliderList; let i = index">
        <img src="{{sliderUrl + slide.image}}" alt="Slide {{i + 1}}">
      </div>
    </div>
    <div class="paginator">
      <span *ngFor="let slide of sliderList; let i = index" 
            class="dot" 
            [ngClass]="{'active-dot': i === currentSlide}" 
            (click)="goToSlide(i)">
      </span>
    </div>
  </div>
</div>

<div class="product_sec">
    <div class="container">
          <div class="secHead">
            <h2> <span class="regular">Popular</span> Products</h2>
             <span class="view_all" (click)="getCategoryProduct(59)"> View all
              <lucide-icon name="chevron-right" class="viewAllIcon" [size]="16" ></lucide-icon>
             </span>
          </div>
          <div class="row">
            <div class="col-sm-3 col-6 pdb" *ngFor="let product of productList">
              <div class="productItem">
                <div class="product-card" (click)="redirectProductDetail(product?.id)">
                  <span class="product-image">
                    <img src="{{product?.base_image?.original_image_url}}" alt="" srcset="" />
                  </span>
                  <h5 class="product-name" matTooltip="{{ product?.name }}">{{ product?.name }}</h5> 
                </div>
                <button mat-button class="product-btn" (click)="addToCart(product)">Add to Cart</button>
              </div> 
            </div>
          </div>
    </div>
</div>


<div class="product_sec popularCategory">
    <div class="container">
      <div class="secHead">
        <h2> <span class="regular">Popular</span> Categories</h2>
        <!-- <span class="view_all"> View all 
          <lucide-icon name="chevron-right" class="viewAllIcon" [size]="16" ></lucide-icon>
        </span> -->
      </div>
      <div class="popularCategoryList">
        <ngx-slick-carousel class="carousel" 
          #slickModal="slick-carousel" 
          [config]="slickCapabilitesConfig"
        >
          <div ngxSlickItem class="product_box" *ngFor="let catItem of popularCategoryList">
            <figure class="prdt_img" (click)="getRelatedProducts(catItem.data.id)">
              <img src="{{catItem.data.logo_url}}" alt=""></figure>
            <h4  (click)="getRelatedProducts(catItem.data.id)">{{catItem.data.name}}</h4>
            <!-- <button mat-button class="btn-custom btn-solid">View All</button> -->
          </div>
        </ngx-slick-carousel>
      </div>
      
    </div>
</div>

<section class="offering">
  <div class="container">
    <div class="secHead">
      <h2 class="medium"> <span class="light">Our</span> Offering</h2>
    </div>
    <div class="row">
      <div class="col-md-3 col-12">
        <div class="offerItem">
         <div class="innerView">
            Custom Part<br> Manufacturing 
            <span routerLink="/about">
              <lucide-icon name="move-up-right"  [size]="24" color="#DA2129" ></lucide-icon>
            </span>
         </div>
        </div>
      </div>
      <div class="col-md-3 col-12">
        <div class="offerItem">
          <div class="innerView">
            Tool<br> Manufacturing
            <span routerLink="/about">
              <lucide-icon name="move-up-right"  [size]="24" color="#DA2129" ></lucide-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-12">
        <div class="offerItem">
          <div class="innerView">
            Strategic Sourcing<br> Partnership
            <span routerLink="/about">
              <lucide-icon name="move-up-right"  [size]="24" color="#DA2129" ></lucide-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-12">
        <div class="offerItem">
          <div class="innerView">
            Sourcing for <br>EPC
            <span routerLink="/about">
              <lucide-icon name="move-up-right"  [size]="24" color="#DA2129" ></lucide-icon>
            </span>
          </div>
        </div>
      </div>
    </div>

  </div>
</section>
<!-- <div class="product_sec bottom">
   <div class="banner">
    <img src="../../../../assets/images/banner.png">
   </div>
</div> -->

<div class="summitPopup" *ngIf="isSummitShow">
  <div class="popupWrapp">
    <lucide-icon name="x" class="icon" [size]="24" color="#666" (click)="closeSummitPopup()"></lucide-icon>
    <img src="../../../../assets/images/EmailFlyer.jpg" alt="" (click)="openFlyerLink()" />
  </div>
</div>
